import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { TableBaseComponent } from "../table-base/table-base.component";
import { Organization } from "../../../models/organization.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { UserService } from "../../../../core/services/user.service";

@Component({
  selector: 'app-organization-table',
  templateUrl: './organization-table.component.html'
})
export class OrganizationTableComponent extends TableBaseComponent<Organization> {

  @Input() detailLink = '/organizations';

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected config: ConfigurationService,
              protected userService: UserService) {
    super(router, route, config, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getGlobalFilterFields() {
    this.globalFilters = this.globalFilters || [{
      label: 'Name',
      field: 'name.value',
      active: true
    }];

    return this.globalFilters
      .filter(filter => filter.active)
      .map(filter => filter.field);
  }

}
